import { LocalStorageKey } from '@/shared/config';
import { safeLocalStorage } from '@/shared/lib';

// NOTE: localStorage is a temporary home for the brightness/contrast sync
// preference; it should move to server-side user settings once they exist.
export const parseFullHeadMprImageOptionsSync = (
  value: string | null,
  fallback = true,
): boolean => (value === 'true' ? true : value === 'false' ? false : fallback);

export const readFullHeadMprImageOptionsSync = (): boolean =>
  parseFullHeadMprImageOptionsSync(
    safeLocalStorage.getItem(LocalStorageKey.fhmprImageOptionsSync),
  );

export const writeFullHeadMprImageOptionsSync = (enabled: boolean): void => {
  safeLocalStorage.setItem(
    LocalStorageKey.fhmprImageOptionsSync,
    String(enabled),
  );
};
